/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createTrue } from '../../factoriesAny.js';
export var trueDependencies = {
  createTrue: createTrue
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesTrue.generated.js
// module id = 1536
// module chunks = 0